module.exports = __webpack_public_path__ + "img/background.4e89b5f7.jpg";